import { cn } from "../../utils/cn"
import { getAvatarInitials } from "./avatarUtils"

type DsAvatarProps = {
  alt?: string
  className?: string
  name: string
  size?: number
  src?: string
}

function DsAvatar({ alt, className, name, size = 40, src }: DsAvatarProps) {
  const initials = getAvatarInitials(name)
  const dimensionStyle = { height: size, width: size }

  if (src) {
    return (
      <img
        alt={alt ?? name}
        className={cn("shrink-0 rounded-full object-cover", className)}
        data-slot="avatar-image"
        src={src}
        style={dimensionStyle}
      />
    )
  }

  return (
    <span
      aria-hidden={alt ? undefined : true}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-dark-light-mode-background font-inter font-semibold text-[14px] text-brand-primary-3 leading-normal tracking-normal",
        className
      )}
      data-slot="avatar-placeholder"
      style={dimensionStyle}
    >
      {initials}
    </span>
  )
}

export { DsAvatar }
export type { DsAvatarProps }
